import { render, staticRenderFns } from "./create_epic_form.vue?vue&type=template&id=0acb67db&"
import script from "./create_epic_form.vue?vue&type=script&lang=js&"
export * from "./create_epic_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports